// extracted by mini-css-extract-plugin
export default {"container":"ExtWindowTrim_container__vhVQy","productListContainer":"ExtWindowTrim_productListContainer__4wk7i","productGrid":"ExtWindowTrim_productGrid__wFVEB"};